import { QUnitType } from "dayjs";
import { TTimeBlockType } from "lobbie";

export const DEFAULT_APPOINTMNET_WARNING_THRESHOLD_MINUTES = 60;
export const APPOINTMENT_TIME_BLOCK_LENGTH = 15;
export const SCHEDULE_BLOCK_TIME_UNITS = "minutes" as const;

export const TIME_BLOCK_TYPES: TTimeBlockType = {
    UNSCHEDULED: 0,
    AVAILABLE: 1,
    SCHEDULED: 2,
};

export const EVV_CLOCK_IN_OUT_DISTANCES = {
    CIRCLE_ANIMATOIN_MAX_DISTANCE_IN_KILOMETERS: 10.37,
    WITHIN_RANGE_DISTANCE_IN_KILOMETERS: 0.37,
};

export const APPOINTMENT_STATUS: {
    UNCONFIRMED: 0;
    CONFIRMED: 1;
    CANCELLED: 2;
    NO_SHOW: 3;
} = {
    UNCONFIRMED: 0,
    CONFIRMED: 1,
    CANCELLED: 2,
    NO_SHOW: 3,
};

// https://github.com/typescript-eslint/typescript-eslint/issues/2447
// eslint-disable-next-line
export enum EAppointmentStatus {
    SCHEDULED = 0,
    CANCELLED = 1,
    NO_SHOW = 2,
    CHECKED_IN = 3,
    IN_TREATMENT = 4,
    CHECKED_OUT = 5,
    CONFIRMED = 6,
    RESCHEDULED = 7,
}

// eslint-disable-next-line no-shadow
export enum EActionItemStatus {
    UNKNOWN = 0,
    CANCELLED = 1,
    NO_SHOW = 2,
    LONG_WAIT = 3,
    RESCHEDULED = 4,
    ARCHIVED = 5,
    NOTIFIED = 6,
}

// https://github.com/typescript-eslint/typescript-eslint/issues/2447
// eslint-disable-next-line
export enum EAppointmentAction {
    CANCEL = "cancel",
    NO_SHOW = "no show",
    ROOM_IN = "room in",
    CHECK_IN = "check in",
    CHECK_OUT = "check out",
    CONFIRM = "confirm",
}

// https://github.com/typescript-eslint/typescript-eslint/issues/2447
// eslint-disable-next-line
export enum EAppointmentStateInTable {
    CANCELLED,
    NO_SHOW,
    MISSED,
    SCHEDULED,
    CLOCKED_IN,
    IN_TREATMENT,
    COMPLETED,
    LATE,
    NEW_LOCATION,
    EXPECTED_LOCATION,
    NOT_APPLICABLE,
    NORMAL,
}

// https://github.com/typescript-eslint/typescript-eslint/issues/2447
// eslint-disable-next-line
export enum EClockAction {
    ClockIn,
    ClockOut,
}

// https://github.com/typescript-eslint/typescript-eslint/issues/2447
// eslint-disable-next-line
export enum ENotificationStatus {
    Unprocessed = "UNPROCESSED",
    ProcessedSent = "PROCESSED_SENT",
    ProcessedUnsent = "PROCESSED_UNSENT",
}

// https://github.com/typescript-eslint/typescript-eslint/issues/2447
// eslint-disable-next-line
export enum EOAMStatus {
    READY = 1,
    SENT = 2,
    EXPIRED = 3,
    ACCEPTED = 4,
    OPT_OUT = 5,
}

export const SCHEDULER: {
    BLOCK_SIZE: number;
    BLOCK_UNIT: QUnitType;
    BLOCK_UNITS: QUnitType;
} = {
    BLOCK_SIZE: 15,
    BLOCK_UNIT: "minute",
    BLOCK_UNITS: "minute",
};

export const APPOINTMENT_COLORS = {
    Red: {
        dark: "#A42614",
        primary: "#BC2719",
        light: "#D88177",
    },
    Orange: {
        dark: "#DA5A32",
        primary: "#EDA24B",
        light: "#FFB661",
    },
    Yellow: {
        dark: "#D6B920",
        primary: "#F1D128",
        light: "#E7D853",
    },
    Green: {
        dark: "#1B5128",
        primary: "#397E49",
        light: "#58BD7F",
    },
    Blue: {
        dark: "#232D7C",
        primary: "#2B46FF",
        light: "#459ADF",
    },
    Purple: {
        dark: "#4F036D",
        primary: "#822EA4",
        light: "#7B86C5",
    },
    Turquoise: {
        dark: "#176090",
        primary: "#1282B1",
        light: "#71B6D2",
    },
    Black: {
        dark: "#3A3A3A",
        primary: "#656565",
        light: "#ABABAB",
    },
};

export const APPOINTMENT_COLORS_LIST = [
    "#A42614",
    "#BC2719",
    "#D88177",
    "#DA5A32",
    "#EDA24B",
    "#FFB661",
    "#D6B920",
    "#F1D128",
    "#E7D853",
    "#1B5128",
    "#397E49",
    "#58BD7F",
    "#232D7C",
    "#2B46FF",
    "#459ADF",
    "#4F036D",
    "#822EA4",
    "#7B86C5",
    "#176090",
    "#1282B1",
    "#71B6D2",
    "#3A3A3A",
    "#656565",
    "#ABABAB",
];

export const TELEHEALTH_OPTIONS = {
    NotTelehealth: {
        value: 0,
        option: "Not Telehealth",
    },
    TelehealthFormsRequired: {
        value: 1,
        option: "Telehealth Forms Required",
    },
    TelehealthFormsNotRequired: {
        value: 2,
        option: "Telehealth Forms Not Required",
    },
};
